<div class="d-flex flex-wrap">
	<p-button pRipple styleClass="p-button-raised m-2" [disabled]="!customerVenueStatisticSelected" (click)="selectSortStatistic(1)">
		<ng-template pTemplate="content">
			<div class="justify-content-center"><fa-icon [icon]="['far', 'funnel-dollar']" size="lg" class="ms-1 me-2"></fa-icon>Most Revenue</div>
		</ng-template>
	</p-button>
	<p-button pRipple styleClass="p-button-raised m-2" [disabled]="!customerVenueStatisticSelected" (click)="selectSortStatistic(2)">
		<ng-template pTemplate="content">
			<div class="justify-content-center"><fa-icon [icon]="['far', 'utensils-alt']" size="lg" class="ms-1 me-2"></fa-icon> Most Visits</div>
		</ng-template>
	</p-button>
	<p-button pRipple styleClass="p-button-raised m-2" [disabled]="!customerVenueStatisticSelected" (click)="selectSortStatistic(3)">
		<ng-template pTemplate="content">
			<div class="justify-content-center"><fa-icon [icon]="['far', 'hand-holding-usd']" size="lg" class="ms-1 me-2"></fa-icon> Avg Spend</div>
		</ng-template>
	</p-button>
</div>
<p-table #dt styleClass="p-datatable-responsive-demo w-100" [value]="customerVenueStatisticSelected" dataKey="sk">
	<ng-template pTemplate="caption">
		<div class="table-header d-flex h4 justify-content-center text-center">
			<span *ngIf="viewMode === 1"> Guests with top overall spend. </span>
			<span *ngIf="viewMode === 2"> Most frequently visiting guests. </span>
			<span *ngIf="viewMode === 3"> Guests with the highest average spend per visit. </span>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th pSortableColumn="customer.lastName">
				Name
				<p-sortIcon field="customer.lastName"></p-sortIcon>
			</th>
			<th pSortableColumn="statisticValue">
				<span *ngIf="viewMode === 1">
					<i>$$$</i>
				</span>
				<span *ngIf="viewMode === 2"> Visits </span>
				<span *ngIf="viewMode === 3">
					<i>$$$ /visit</i>
				</span>
				<p-sortIcon field="statisticValue"></p-sortIcon>
			</th>
			<th pSortableColumn="customer.lastVisit">
				Last Visit
				<p-sortIcon field="customer.lastVisit"></p-sortIcon>
			</th>
			<!-- <th style="width: 40%">Tags</th> -->
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>
				<span class="p-column-title">Name</span>
				<p-skeleton *ngIf="!rec.customer"></p-skeleton>
				{{ rec.customer?.lastName }}, {{ rec.customer?.firstName }}
			</td>
			<td>
				<span *ngIf="viewMode === 1" class="p-column-title">
					<i>$$$</i>
				</span>
				<span *ngIf="viewMode === 2" class="p-column-title"> Visits </span>
				<span *ngIf="viewMode === 3" class="p-column-title">
					<i>$$$ /visit</i>
				</span>
				<span *ngIf="viewMode === 1 || viewMode === 3">
					{{ rec.statisticValue | currency }}
				</span>
				<span *ngIf="viewMode === 2"> {{ rec.statisticValue }} visits </span>
			</td>
			<td>
				<span class="p-column-title">Last Visit</span>
				{{ moment(rec.customer.lastVisitDate).format("l") }}
			</td>
			<!-- <td class="d-flex station-status">
				<p-chip *ngFor="let tag of rec.customer.tags" styleClass="station mx-2 custom-chip">{{ tag }}</p-chip>
			</td> -->
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="4" class="text-center">No customers found.</td>
		</tr>
	</ng-template>
</p-table>
